import { has } from "markdown-it/lib/common/utils";
import { STATS_STATE } from "../core/constants";
import { getDomainCfg } from "../core/state";
import { getComponentData, setComponentData } from "../core/views";
import e from "express";
import { logGamificationEvent } from "./gamification/events";
import { stat } from "fs";
import { checkNextWaypoint, getQuestDataForId } from "../core/quest/questloader";

const statsKey = () : string => {
  return btoa(`${getDomainCfg().baseUrl}@stats`);
}

export const initUserStats = () : void => {
  if (hasUserStats()) {
    loadLocalStats();
  }
}

export const hasUserStats = () : boolean => {
  return localStorage.getItem(statsKey()) !== null;
}

export const loadLocalStats = () => {
  const localStats = localStorage.getItem(statsKey());
  if (localStats === null) {
    return;
  }

  const statsString = atob(localStats);
  const statsData = getComponentData(STATS_STATE);
  statsData.stats = JSON.parse(statsString);
  setComponentData(STATS_STATE, statsData);
}

export const saveLocalStats = () : void => {
  const statsData = getComponentData(STATS_STATE);
  const statsString = JSON.stringify(statsData.stats);
  console.log('save stats', statsString);
  const localStats = btoa(statsString);
  localStorage.setItem(statsKey(), localStats);
}

const defaultStats = () => {
  return {
    stats : {
      visits : 0,
      logins : 0,
      completed : 0,
      lastLoginDate : "",
      quests :[]
    }
  }
}

export const addVisit = () : void => {
  
  const statsData = getComponentData(STATS_STATE);
  let newStatsData = defaultStats();
  if (statsData.stats) {   
    newStatsData = {
      stats : {
        ...statsData.stats,
        visits: statsData.stats.visits + 1,
      }
    }
  }
  setComponentData(STATS_STATE, newStatsData);
  saveLocalStats();
}

export const firstVisit = () : boolean => {
  loadLocalStats();  
  if (!getComponentData(STATS_STATE).stats) {
    return true
  }
  return getComponentData(STATS_STATE).stats?.visits < 1;
}

function isValidDate(d: Date): boolean {
  return d instanceof Date && !isNaN(d.getTime());
}


export const addLogin = () : void => {
  let statsData = getComponentData(STATS_STATE);
  let newStatsData = defaultStats();
  const today = new Date().toISOString().split('T')[0];  // Heutiges Datum im Format YYYY-MM-DD
  
  if (statsData.stats) {    
    newStatsData = {
      stats : {
        ...statsData.stats,
        logins : statsData.stats.logins + 1
      }
    }

    // Überprüfen, ob sich der Benutzer gestern angemeldet hat
    const lastLoginDate = new Date(statsData.stats.lastLoginDate);
    const yesterday = new Date();
    yesterday.setDate(yesterday.getDate() - 1);

    if (isValidDate(lastLoginDate) && lastLoginDate.toISOString().split('T')[0] === yesterday.toISOString().split('T')[0]) {      
      logGamificationEvent("LoginStreak", "Continuos Login", "");      
    }

    // Aktualisieren Sie das letzte Anmeldedatum auf heute
    newStatsData.stats.lastLoginDate = today;
  }

  setComponentData(STATS_STATE, newStatsData);
  saveLocalStats();
}

export const firstLogin = () => {
  loadLocalStats();
  if (!getComponentData(STATS_STATE).stats) {
    return true
  }
  return getComponentData(STATS_STATE).stats?.logins < 2;
}

export const addCompletedApp = () : void => {
  const statsData = getComponentData(STATS_STATE);
  let newStatsData = defaultStats();
  if (statsData.stats) {    
    newStatsData = {
      stats : {
        ...statsData.stats,
        completed : statsData.stats.completed + 1
      }
    }
  }
  statsData.stats.completed++;
  setComponentData(STATS_STATE, newStatsData);
  saveLocalStats();
}

export const completedApps = () : number => {
  loadLocalStats();
  return getComponentData(STATS_STATE).stats?.completed;
}

export const nextQueryWaypoint = async (questId : string, projectId : string) : Promise<void> => {

  //if yes, increase achievement by 1
  const statsData = getComponentData(STATS_STATE);
  let newStatsData = defaultStats();
  if (statsData.stats && statsData.stats.quests) {
    let newQuestsArray = [...statsData.stats.quests] || [];
    const questIndex = statsData.stats.quests?.findIndex((quest) => quest.id === questId);
    if (questIndex > -1) {
      const currentQuest = statsData.stats.quests[questIndex];
      const nextWaypointValid = await checkNextWaypoint(questId, projectId, currentQuest.achievement);
      if (!nextWaypointValid) {
        return;
      }
      let newQuest = {
        ...statsData.stats.quests[questIndex]
      }
      newQuest.achievement = newQuest.achievement + 1;      
      newQuestsArray[questIndex] = newQuest;
    } else {
      newQuestsArray.push({
        id : questId,
        achievement : 1
      });
    }
    newStatsData = {
      stats : {
        ...statsData.stats,
        quests : newQuestsArray
      }
    }
  } else {
    const newQuestsArray = [];
    newQuestsArray.push({
      id : questId,
      achievement : 1
    });
    newStatsData = {
      stats : {
        ...statsData.stats,
        quests : newQuestsArray
      }
    }
  }
  setComponentData(STATS_STATE, newStatsData);
  saveLocalStats();
}

export const unlockQuest = (questId : string) : void => {
  const statsData = getComponentData(STATS_STATE);
  let newStatsData = defaultStats();
  if (statsData.stats) {
    let newQuestsArray = [...statsData.stats.quests] || [];
    const questIndex = statsData.stats.quests?.findIndex((quest) => quest.id === questId);
    if (questIndex > -1) {
      let newQuest = {
        ...statsData.stats.quests[questIndex]
      }
      newQuest.achievement = 0;      
      newQuestsArray[questIndex] = newQuest;
    } else {
      newQuestsArray.push({
        id : questId,
        achievement : 0
      });
    }
    newStatsData = {
      stats : {
        ...statsData.stats,
        quests : newQuestsArray
      }
    }
  }
  setComponentData(STATS_STATE, newStatsData);
  saveLocalStats();
}

export const getCurrentQuestAchievement = (questId : string) : number => {
  loadLocalStats();
  const statsData = getComponentData(STATS_STATE);
  const quest = statsData.stats?.quests?.find((quest) => quest.id === questId);
  if (quest) {
    return quest.achievement;
  }
  return -1;
}
